// src/components/assets/shared/Pagination.tsx
import React from 'react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  startIndex: number;
  endIndex: number;
  handlePageChange: (page: number) => void;
  handleItemsPerPageChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  isMobile?: boolean;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage, totalPages, totalItems, itemsPerPage, startIndex, endIndex,
  handlePageChange, handleItemsPerPageChange, isMobile
}) => {
  if (isMobile) {
    return (
      <div className="p-4 flex flex-col items-center space-y-2">
        <div className="text-sm text-gray-600">
            Showing {startIndex + 1} to {Math.min(endIndex, totalItems)} of {totalItems} records
        </div>
        <div className="flex items-center space-x-2">
          <select value={itemsPerPage} onChange={handleItemsPerPageChange} className="p-1 border border-gray-300 rounded-lg text-sm">
            {[5, 10, 25, 50].map(size => (<option key={size} value={size}>{size} per page</option>))}
          </select>
          <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="px-3 py-1 bg-gray-200 text-gray-600 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed">
            Prev
          </button>
          <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="px-3 py-1 bg-gray-200 text-gray-600 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed">
            Next
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 flex justify-between items-center border-t border-gray-200">
        <div className="flex items-center space-x-2 text-sm text-gray-600">
            <span>Show</span>
            <select value={itemsPerPage} onChange={handleItemsPerPageChange} className="p-1 border border-gray-300 rounded-lg text-sm">
                {[5, 10, 25, 50].map(size => (<option key={size} value={size}>{size}</option>))}
            </select>
            <span>per page</span>
            <span>| Showing {startIndex + 1} to {Math.min(endIndex, totalItems)} of {totalItems} records</span>
        </div>
        {totalItems > itemsPerPage && (
            <div className="flex space-x-2">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="px-3 py-1 bg-gray-200 text-gray-600 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed">Previous</button>
                {/* For brevity, not rendering all page numbers. Can be enhanced. */}
                <span className='px-3 py-1'>Page {currentPage} of {totalPages}</span>
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="px-3 py-1 bg-gray-200 text-gray-600 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed">Next</button>
            </div>
        )}
    </div>
  );
};

export default Pagination;